import React, { Component } from 'react';
import update from 'immutability-helper';

import AccountForgotPassword from './AccountForgotPassword';

import { requestPasswordReset } from './helpers';

class AccountForgotPasswordContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      form: {
        state: {
          email: props.location?.state?.email || '',
        },
        saved: false,
        message: '',
      },
    };
  }

  handleInputChange = e => {
    const { target } = e;

    const newState = update(this.state, {
      form: {
        state: {
          [target.name]: {
            $set: target.value,
          },
        },
      },
    });

    this.setState(newState);
  };

  handleSubmit = async e => {
    e.preventDefault();
    if (this.inFlight) return;

    this.inFlight = true;
    this.setState({ submitting: true });
    try {
      await this.submit(e);
    } finally {
      this.inFlight = false;
      this.setState({ submitting: false });
    }
  };

  submit = async e => {
    const {
      form: { state },
    } = this.state;

    e.preventDefault();

    if (!state.email || !state.email.length) {
      const newState = update(this.state, {
        form: {
          message: {
            $set: 'Enter the email address you signed up with.',
          },
        },
      });

      return this.setState(newState);
    }

    const data = Object.assign({}, state);

    const requestedPasswordReset = await requestPasswordReset(data);

    if (!requestedPasswordReset) {
      const newState = update(this.state, {
        form: {
          message: {
            $set: 'Something went wrong. If this error persists, please contact support.',
          },
        },
      });

      return this.setState(newState);
    }

    if (!requestedPasswordReset.meta?.ok && requestedPasswordReset.message) {
      const newState = update(this.state, {
        form: {
          message: {
            $set: requestedPasswordReset.message,
          },
        },
      });

      return this.setState(newState);
    }

    const newState = update(this.state, {
      form: {
        saved: {
          $set: true,
        },
        message: {
          $set: '',
        },
      },
    });

    this.setState(newState);
  };

  handleStartOver = () => {
    this.setState(prev => update(prev, { form: { saved: { $set: false } } }));
  };

  render() {
    return (
      <AccountForgotPassword
        form={this.state.form}
        handleInputChange={this.handleInputChange}
        handleSubmit={this.handleSubmit}
        submitting={!!this.state.submitting}
        handleStartOver={this.handleStartOver}
      />
    );
  }
}

export default AccountForgotPasswordContainer;
